var exports = {
  "G": "xe533113f--a9567a--infrastructure-icon",
};

module.exports = exports;
